// src/pages/in-kind/DonateCrop.js
import InKindForm from "../../components/InKindForm";

function DonateCrop() {
  return <InKindForm contributionType="donate" />;
}

export default DonateCrop;